@use '../../../scss/settings/colors' as colors;

.card_content_min_height {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 213px;
}

.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;
  transform: scale(1);
  padding-bottom: 2rem;
  border: 1px solid transparent;
}

.preferences_card {
  padding-bottom: 6rem;
}

.card_border {
  border: 1px solid colors.$brand-purple;
  animation: pulse 0.4s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.link_style {
  text-decoration: none !important;
  color: inherit !important;
  display: flex !important;
  align-items: center !important;
  font-size: 0.8em !important;
}

.container_margin_top {
  margin-top: 14px !important;
}

.add_social_button {
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
}
